import _ from 'lodash';
export function slugCreatorFactory() {
    var usedStrings = [];
    return function slugCreator(str) {
        var kebabCase = _.kebabCase(str);
        var result = kebabCase;
        var i = 1;
        while (usedStrings.includes(result)) {
            result = kebabCase + "-" + i++;
        }
        usedStrings.push(result);
        return result;
    };
}
//# sourceMappingURL=slugLogic.js.map